import { render } from "./SGOption.vue?vue&type=template&id=6061827d&scoped=true"
import script from "./SGOption.vue?vue&type=script&lang=js"
export * from "./SGOption.vue?vue&type=script&lang=js"

import "./SGOption.vue?vue&type=style&index=0&id=6061827d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6061827d"]])

export default __exports__